export default "__VITE_PUBLIC_ASSET__32ee8cce__"